import { createReducer, on } from '@ngrx/store';

import { setSessionId } from '../actions/conversational-chat.actions';
import { initialConversationalChatState } from '../conversational-chat.state';

export const conversationalChatReducer = createReducer(
  initialConversationalChatState,
  on(setSessionId, (state, { conversationalChatSessionId }) => ({
    ...state,
    conversationalChatSessionId,
  }))
);
